import { useInfiniteQuery } from "react-query";
import axios from "axios";

const fetchPost = async ({ pageParam }) => {
  const url = pageParam
    ? pageParam
    : `https://api.impactrun.com/web/v1/webposts?is_visible_on_app=true`;
    const {
      data: { response },
    } = await axios.get(url);
    return response
};

export const PostListQuery = () =>
  useInfiniteQuery("PostList", fetchPost, {
    getNextPageParam: (lastPage, allPages) => lastPage.next,
  });
